<template>
  <div>
    <ul>
      <template v-for="item in items">
        <li :to="item.path" :key="item.name">
          <router-link :to="item.path">{{item.name}}</router-link>
        </li>
      </template>
      <li>
        <a href="/index_f7.html" target="_blank">index_f7</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: { dummy: function () {} },
  created () {
    this.$router.options.routes.forEach(route => {
      this.items.push({
        name: route.name,
        path: route.path
      })
    })
  },
  data () {
    return {
      items: []
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Root.vue